import {
  SAVE_ALL_KHEDMAT,
  SAVE_ALL_KHEDMATSYS,
  KHADAMAT_SEARCH,
} from "Stores/actionTypes";
import StatusHandler from "Helpers/StatusHandler";
import UtilityService from "Services/http/endpoints/properties/UtilityService";
import { analyzePrice } from "Helpers/analyzePrice";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const GetKhedmatSys = (params) => {
  return async (dispatch) => {
    try {
      const response = await UtilityService.GetKhedmatSys(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const update = data.map((m) => {
          return {
            ...m,
            value: m.Id,
            label: m.Name,
          };
        });
        dispatch({
          type: SAVE_ALL_KHEDMATSYS,
          khedmatSys: update,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const GetAllKhedmat = (params) => {
  return async (dispatch) => {
    try {
      const response = await UtilityService.GetAllKhedmat(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = analyzePrice(response.data.Value);
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const updatedData = data.map((data, index) => {
          return {
            ...data,
            num: ((page - 1 ) * limit) + index + 1,
          };
        });
        dispatch({
          type: SAVE_ALL_KHEDMAT,
          khedmatData: updatedData,
          khedmatDataPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const InsertKhedmatData = (data) => {
  return async (dispatch) => {
    try {
      const response = await UtilityService.InsertKhedmatData(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_new_service_was_successfully_registered'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const EditPriceKhedmat = (data) => {
  return async (dispatch) => {
    try {
      const response = await UtilityService.EditPriceKhedmat(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('changePriceSuccess'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const EditKhedmatAction = (data) => {
  return async (dispatch) => {
    try {
      const response = await UtilityService.EditKhedmatAction(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Service_edited_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteKhedmat = (data) => {
  return async (dispatch) => {
    try {
      const response = await UtilityService.deleteKhedmat(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_service_was_successfully_removed'),
          customClass: "success"
        });
        return true;
      } else {
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const disableKhadamat = (data) => {
  return async (dispatch) => {
    try {
      const response = await UtilityService.disableKhadamat(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changeKhadamtSearch = (khedmatDataSearch) => (dispatch) => {
  dispatch({
    type: KHADAMAT_SEARCH,
    khedmatDataSearch: khedmatDataSearch,
  });
};
